var ContentPreviewType = /*#__PURE__*/ function(ContentPreviewType) {
    ContentPreviewType["Audio"] = "audio";
    ContentPreviewType["Image"] = "image";
    ContentPreviewType["OfficeDoc"] = "office";
    ContentPreviewType["PDF"] = "pdf";
    ContentPreviewType["VideoMux"] = "mux";
    ContentPreviewType["VideoOther"] = "video";
    ContentPreviewType["VideoProcessing"] = "processing";
    return ContentPreviewType;
}({});

export { ContentPreviewType };
//# sourceMappingURL=attachment.js.map
